import React from 'react';
import { Box } from '@wds/box';
import { InputGroup, InputGroupAddon } from '@wds/input-group';
import { Input } from '@sm/wds-react';
import { IconSearch } from '@wds/icons';
import { SearchConsumer } from '~app/pages/AppsDirectory/components/SearchContext';

const SearchBox = () => {
  return (
    <Box display="inline">
      <SearchConsumer>
        {({ search, updateSearch }) => (
          <InputGroup stretched>
            <Input placeholder="Search the App Directory" value={search} onChange={e => updateSearch(e.target.value)} />
            <InputGroupAddon>
              <IconSearch title="Search " />
            </InputGroupAddon>
          </InputGroup>
        )}
      </SearchConsumer>
    </Box>
  );
};

export default SearchBox;
